export default __webpack_public_path__ + "static/media/ppnTherapist1Small.1c2abfce.jpg";